document.addEventListener('DOMContentLoaded', function () {
	const menus = document.querySelectorAll('[data-custom-menu]');

	menus.forEach(menu => {
		const tabButtons = menu.querySelectorAll('[role="tab"]');
		const navContainer = menu.querySelector('nav');

		tabButtons.forEach(button => {
			button.addEventListener('click', function () {
				const targetPanelId = this.getAttribute('aria-controls');
				const targetPanel = document.getElementById(targetPanelId);

				// Don't do anything if clicking the already active tab
				if (this.getAttribute('aria-selected') === 'true') return;

				// Get current panel within this menu
				const currentPanel = menu.querySelector('[role="tabpanel"]:not([hidden])');

				if (currentPanel && navContainer) {
					// Get the nav container's padding
					const navStyle = window.getComputedStyle(navContainer);
					const paddingTop = navStyle.paddingTop;
					const paddingBottom = navStyle.paddingBottom;

					// Set starting height (total height including padding)
					const currentHeight = navContainer.offsetHeight;
					navContainer.style.height = currentHeight + 'px';

					// Update button states
					tabButtons.forEach(btn => {
						btn.setAttribute('aria-selected', 'false');
						btn.classList.remove('btn--nav-primary-active');
						btn.classList.add('btn--nav-primary-inactive');
					});

					this.setAttribute('aria-selected', 'true');
					this.classList.remove('btn--nav-primary-inactive');
					this.classList.add('btn--nav-primary-active');

					// Position current panel absolutely with padding
					currentPanel.style.position = 'absolute';
					currentPanel.style.top = paddingTop;
					currentPanel.style.left = '0';
					currentPanel.style.width = '100%';
					currentPanel.style.paddingBottom = paddingBottom;

					// Show target panel and position it with padding
					targetPanel.hidden = false;
					targetPanel.style.opacity = '0';
					targetPanel.style.position = 'relative';
					targetPanel.style.paddingTop = paddingTop;
					targetPanel.style.paddingBottom = paddingBottom;

					// Get new height including the panel's padding
					const newHeight = targetPanel.offsetHeight;
					navContainer.style.height = newHeight + 'px';

					// Trigger crossfade
					requestAnimationFrame(() => {
						currentPanel.style.opacity = '0';
						targetPanel.style.opacity = '1';

						// Clean up after transition
						setTimeout(() => {
							currentPanel.hidden = true;
							currentPanel.style.position = '';
							currentPanel.style.top = '';
							currentPanel.style.left = '';
							currentPanel.style.width = '';
							currentPanel.style.opacity = '';
							currentPanel.style.paddingBottom = '';

							targetPanel.style.paddingTop = '';
							targetPanel.style.paddingBottom = '';

							// Remove fixed height after animation completes
							navContainer.style.height = '';
						}, 300);
					});
				}
			});
		});
	});
});

class AnnouncementBarCustom extends HTMLElement {
	constructor() {
		super();
		this.announcementItemsWrapper = this.querySelector('.swiper-wrapper');

		FoxTheme.Motion.inView(this, this.initializeCarousel.bind(this), { margin: '200px 0px 200px 0px' });
	}

	getNextSlideButton() {
		return this.querySelector('.swiper-button-next');
	}

	getPrevSlideButton() {
		return this.querySelector('.swiper-button-prev');
	}

	get getSlideItems() {
		return (this._cachedSlideItems = this._cachedSlideItems || Array.from(this.announcementItemsWrapper.children));
	}

	isAutoplayEnabled() {
		return this.hasAttribute('autoplay');
	}

	getAutoplaySpeed() {
		return this.hasAttribute('autoplay') ? parseInt(this.getAttribute('autoplay-speed')) * 1000 : 5000;
	}

	initializeCarousel() {
		if (this.getSlideItems.length > 1) {
			this.carousel = new FoxTheme.Carousel(
				this,
				{
					navigation: {
						nextEl: this.getNextSlideButton(),
						prevEl: this.getPrevSlideButton(),
					},
					loop: false,
					autoplay: this.isAutoplayEnabled() ? { delay: this.getAutoplaySpeed(), pauseOnMouseEnter: true } : false,
					breakpoints: {
						enabled: true,
						1024: {
							enabled: false,
						}
					},
				},
				FoxTheme.Swiper.Autoplay
			);
			this.carousel && this.carousel.init();

			if (Shopify.designMode) {
				this.addEventListener('shopify:block:select', (event) => {
					this.carousel.slider.slideToLoop(this.getSlideItems.indexOf(event.target));
				});
			}
		}
	}
}
customElements.define('announcement-bar-custom', AnnouncementBarCustom);
